var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from "../../ApiClient/ApiClient";
class BetaApiClient {
    constructor() {
        this.BASE_PATH = '/zauvu/beta';
        this.createBetaKey = (email) => __awaiter(this, void 0, void 0, function* () {
            const res = yield client.post(this.BASE_PATH, {
                email
            });
            if (res.isOk === true) {
                return res.data.data;
            }
            throw new Error(res.errorMessage);
        });
        this.deleteBetaKey = (id) => __awaiter(this, void 0, void 0, function* () {
            const path = `${this.BASE_PATH}/${id}`;
            const res = yield client.delete(path, {});
            if (res.isOk === true) {
                return;
            }
            throw new Error(res.errorMessage);
        });
    }
}
export const BetaClient = new BetaApiClient();
